import { useCallback, useState, useEffect } from 'react';

interface Props {
  containerRef: React.RefObject<HTMLDivElement>;
}

interface ScrollState {
  left: boolean;
  right: boolean;
}

export const useScrollState = ({ containerRef }: Props) => {
  const [arrows, setArrows] = useState<ScrollState>({ left: false, right: false });

  const checkScroll = useCallback(() => {
    const element = containerRef.current;
    if (!element) return;

    const maxScroll = element.scrollWidth - element.clientWidth;
    const currentScroll = element.scrollLeft;

    setArrows({
      left: currentScroll > 0,
      right: Math.round(currentScroll) < maxScroll - 1
    });
  }, [containerRef]);

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;

    // Initial check and event listeners
    checkScroll();
    element.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);

    // ResizeObserver for dynamic content changes
    const observer = new ResizeObserver(checkScroll);
    observer.observe(element);

    return () => {
      element.removeEventListener('scroll', checkScroll);
      window.removeEventListener('resize', checkScroll);
      observer.disconnect();
    };
  }, [checkScroll]);

  return { ...arrows, checkScroll };
};
